<template>
	<div id="send_recommendation_widget" v-loading="loading">
		<div class="row">
			<div class="col-8">
				<h6 class="heading-small text-muted mb-4">Queued Venues</h6>
			</div>
			<div class="col-4 text-right">
				<a
					@click.prevent="showEmailTemplate"
					class="btn btn-sm btn-primary"
					id="send_venue_recommendation"
					href="#"
				>
					Preview
				</a>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-12" :id="queuedVenuesContainerId">
				<ul
					class="list-group list-group-flush list my--3"
				>
					<li
						v-for="venueRoom in queued_recommendations"
						:key="`${venueRoom.id || venueRoom.venue_id}_${venueRoom.room_id || venueRoom.space}_queued_recommendations`"
						class="list-group-item px-0"
					>
						<div class="row align-items-center">
							<div class="col-auto">
								<span class="avatar">
									<img alt="Image placeholder" :src="venueRoom.thumbnail || venueRoom.image_url" />
								</span>
							</div>
							<div class="col">
								<h5 class="mb-0">{{ venueRoom.name || venueRoom.venue_name }}</h5>
								<small class="text-muted">{{ venueRoom.space || venueRoom.room_name }}</small>
							</div>
							<div class="mr-3" @click="removeFromQueue(venueRoom)">
								<badge
									rounded tag="a" class="btn-remove" href="javascript:"
									type="danger">
									✕ Remove 
								</badge>
							</div>
						</div>
					</li>
				</ul>
				<p class="text-center mt-5" v-if="queued_recommendations.length == 0">Please Add Some Venues</p>
			</div>
		</div>
		<el-dialog
			title="Email Text Template"
			width="50%"
			:visible.sync="recommendationTextEditDialogVisible"
			v-if="recommendationTextEditDialogVisible"
			:close-on-click-modal="false"
			:append-to-body="true"
		>
			<base-input
				type="text"
				label="Email Subject"
				placeholder="Email Subject"
				v-model="emailTemplateSubject"
			>
			</base-input>
			<base-input label="Email Body">
				<html-editor name="editor" :value="emailTemplate" @input="editEmailText"></html-editor>
			</base-input>
			<span slot="footer" class="dialog-footer">
				<button class="btn edit" @click="recommendationTextEditDialogVisible = false">
					Cancel
				</button>
                <button class="btn btn-info edit submit" id="send_venue_recommendation_final" @click.stop="sendRecommendation(false)">
					Save Only
				</button>
				<button class="btn btn-primary edit submit" id="send_venue_recommendation_final" @click.stop="sendRecommendation">
					Save & Send Email
				</button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import RecommendationService from "@/services/recommendation.service";
import EnquiryService from "@/services/enquiry.service";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import { Loading, Dialog } from 'element-ui';
import recommendationMixin from "@/helpers/recommendationMixin";

export default {
	props:{
		leadEventId: {
			required: true
		},
		recommendations: {
			type: Array,
            default: () => []
		},
        queuedVenuesContainerId: {
            type: String,
            default: 'queued_venues'
        }
	},
	data() {
		return {
			recommendationTextEditDialogVisible: false,
			emailTemplateText: '',
			emailTemplateSubject: '',
			portalLoginLink: '',
			loading: true
		};
	},
	components: {
		[Dialog.name]: Dialog,
		[HtmlEditor.name]: HtmlEditor,
		HtmlEditor
	},
	mixins: [ recommendationMixin ],
	computed: {
		emailTemplate() {
			return this.isCountryAU ? this.auEmailTemplate : this.ukEmailTemplate;
		},

		queued_recommendations() {
			return this.roomsSelectedForRecommendation;
		},

		leadInfo() {
			return this.$store.getters["leadEvent/getLeadEventsById"](this.leadEventId);
		}
	},
	async mounted() {
		await this.$store.dispatch("leadEvent/getSingle", this.leadEventId);
		this.loading = false;
	},
	methods: {
		removeFromQueue(venueRoom) {
            let temp = this.roomsSelectedForRecommendation;
            let index = -1;

            if (venueRoom.room_id == null && venueRoom.room_name == 'Entire Venue') {
                index = temp.findIndex(room => room.room_name == 'Entire Venue' && room.venue_id == venueRoom.venue_id);
            } else {
                index = temp.indexOf(venueRoom);
            }

            if (index > -1) {
                temp.splice(index, 1);
                this.updateRecommendationShortList(temp);
			}
		},
        updateRecommendationShortList(venueRooms) {
            this.$store.commit('recommendations/updateSelectedForRecommendation', {
                leadEventId: this.leadEventId,
                rooms: venueRooms,
            });
        },
		showEmailTemplate() {
			if (!this.queued_recommendations.length) {
				return;
			}

			this.recommendationTextEditDialogVisible = true;
			this.emailTemplateSubject = this.emailSubjectMessage;
			this.getCompatibleVenuesObject();
			this.$emit('previewed');
		},

		async sendRecommendation(sendEmail) {
			if (!this.queued_recommendations.length) {
				return;
			}

			const loading = this.loadingState();
			await this.$store.dispatch("recommendations/sendRecommendation", {
				leadEventId: this.leadEventId,
				venues: this.queued_recommendations,
				template: this.emailTemplateText ? this.emailTemplateText : this.emailTemplate,
				subject: this.emailTemplateSubject ? this.emailTemplateSubject : this.emailSubjectMessage,
				portalLink: this.portalLoginLink,
                doNotSendEmail: ! sendEmail
			});

            this.updateRecommendationShortList([]);

			this.recommendationTextEditDialogVisible = false;

			await this.$store.dispatch('recommendations/getRecommendations', this.leadEventId);

			const results = await this.searchVenues(this.$route.params.id, this.$route.params.eventId);
            const recommendableVenues = results?.data?.venues || {};
			if (Object.keys(recommendableVenues)?.length) {
                this.$store.commit('recommendations/updateKarenVenuesForListView', recommendableVenues);
			}

			loading.close();
		},

		editEmailText(text) {
			this.emailTemplateText = text;
		},

		loadingState() {
			return Loading.service({
				lock: true,
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},

		getCompatibleVenuesObject() {
			let venuesObject = [];
			this.queued_recommendations.forEach(function(venue) {
				if (! venue.id) {
					venue.id = venue.venue_id;
				}

				if (! venue.space) {
					venue.space = venue.room_name
				}

				venuesObject.push(venue);
			});

			return venuesObject;
		}
	},
	watch: {
		leadInfo: function () {
			this.getPortalLink(this.leadInfo.lead_id);
		}
	}
};
</script>
<style>
.ql-editor {
	word-break: normal;
}
</style>